import { useEffect, useRef } from "react";

export const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  isOpen: boolean,
  onClose: () => void
) => {
  const enabledRef = useRef(false);

  useEffect(() => {
    if (!isOpen) {
      enabledRef.current = false;
      return;
    }

    // Delay enabling the handler until AFTER the event loop
    const t = setTimeout(() => {
      enabledRef.current = true;
    }, 0);

    const handleClick = (event: MouseEvent) => {
      if (!enabledRef.current) return;
      if (!ref.current || ref.current.contains(event.target as Node)) return;
      onClose();
    };

    document.addEventListener("click", handleClick);

    return () => {
      enabledRef.current = false;
      clearTimeout(t);
      document.removeEventListener("click", handleClick);
    };
  }, [isOpen, ref, onClose]);
};